"use strict";

var _taggedTemplateLiteral = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation FileCreate($data: FileCreateInput!) {\n    fileCreate(data: $data) {\n      id\n      fileId\n      filename\n      provider\n      uploadUrl\n      downloadUrl\n      public\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILE_PICKER__CREATE_FILE_MUTATION = void 0;

var tslib_1 = require("tslib");

var graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));

exports.FILE_PICKER__CREATE_FILE_MUTATION = (0, graphql_tag_1.default)(_templateObject());